import '../js/oss.info';

export const getToken = () => {
  return new Promise((resolve, reject) => {
    if (window === window.parent) {
      reject('没有父对象');
    } else {
      window.parent.postMessage('{"type": "getToken"}', '*');
      window.addEventListener('message', e => {
        const data = JSON.parse(e.data);
        switch (data.type) {
          case 'getToken':
            resolve(data.token);
            break;
        }
      });
    }
  });
};

export const PromiseWidget = {
  to: promise => {
    if (!promise || !Promise.prototype.isPrototypeOf(promise)) {
      return new Promise((resolve, reject) => {
        reject(new Error("requires promises as the param"));
      }).catch((err) => {
        return [err, null];
      });
    }
    return promise.then(function () {
      return [null, ...arguments];
    }).catch(err => {
      return [err, null];
    });
  }
};

export const getOSSParams = (accessId, accessKey) => {
  const policyText = {
    "expiration": "2029-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    "conditions": [
      ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
    ]
  };

  const policyBase64 = window.Base64.encode(JSON.stringify(policyText))
  const bytes = window.Crypto.HMAC(window.Crypto.SHA1, policyBase64, accessKey, {
    asBytes: true
  });
  const signature = window.Crypto.util.bytesToBase64(bytes);

  return {
    'policy': policyBase64,
    'OSSAccessKeyId': accessId,
    'success_action_status': '200', //让服务端返回200,不然，默认会返回204
    'signature': signature,
  }
};

export const unitList = [{
  key: 'byte',
  value: Math.pow(1024, 0)
}, {
  key: 'KB',
  value: Math.pow(1024, 1)
}, {
  key: 'MB',
  value: Math.pow(1024, 2)
}, {
  key: 'GB',
  value: Math.pow(1024, 3)
}, {
  key: 'TB',
  value: Math.pow(1024, 4)
}, {
  key: 'PB',
  value: Math.pow(1024, 5)
}];

export const changeByte = byte => {
  for (let i = 0; i < unitList.length; i++) {
    if (byte / unitList[i].value < 1024) {
      return (byte / unitList[i].value).toFixed(2) + unitList[i].key;
    }
  }
};
